import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Droplets, Home, Leaf, Briefcase } from "lucide-react";
const services = [{
  id: 1,
  title: "Flächenreinigung ohne Chemie",
  description: "Professionelle Hochdruckreinigung von Terrassen, Einfahrten, Pflaster und Parkplätzen – ausschließlich mit Wasser, umweltfreundlich und materialschonend.",
  icon: "droplets"
}, {
  id: 2,
  title: "Hausmeisterservice",
  description: "Zuverlässige Hausmeistertätigkeiten im nicht handwerkspflichtigen Bereich für Privathaushalte, Hausverwaltungen und Unternehmen.",
  icon: "home"
}, {
  id: 3,
  title: "Gartenpflege",
  description: "Umfassende Gartenpflege inkl. Hecken- und Rasenschnitt, Strauchschnitt, Laubbeseitigung und saisonale Pflege für gepflegte Außenanlagen.",
  icon: "leaf"
}, {
  id: 4,
  title: "Büroorganisation",
  description: "Bürotätigkeiten und professionelle Hilfeleistungen im Bereich Büroorganisation für effiziente Arbeitsabläufe.",
  icon: "briefcase"
}];
export default function OurGardenMaintenanceServices() {
  const getIcon = (iconName: string) => {
    switch (iconName) {
      case "droplets":
        return <Droplets className="size-8 text-primary" />;
      case "home":
        return <Home className="size-8 text-primary" />;
      case "leaf":
        return <Leaf className="size-8 text-primary" />;
      case "briefcase":
        return <Briefcase className="size-8 text-primary" />;
      default:
        return <Droplets className="size-8 text-primary" />;
    }
  };
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="text-4xl font-bold text-foreground mb-4">
            Unsere Leistungen
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Münsterland Industrieservice UG (haftungsbeschränkt) bietet professionelle Dienstleistungen im Münsterland – Flächenreinigung, Hausmeisterservice, Gartenpflege und Büroorganisation auf höchstem Niveau.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => <Card key={service.id} data-index={i} className="border border-border shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] hover:-translate-y-1">
              <CardHeader>
                <div className="mb-4">{getIcon(service.icon)}</div>
                <CardTitle className="text-xl text-foreground">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-muted-foreground leading-relaxed">
                  {service.description}
                </CardDescription>
              </CardContent>
              <CardFooter>
                <Link to="/KontaktPage" className="w-full">
                  <Button className="w-full bg-primary text-primary-foreground hover:bg-primary-hover transition-colors">
                    Angebot anfordern
                  </Button>
                </Link>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}